import { WldDocumentSharingConsent, WldTermsContent } from '@interfaces';
import { UploadedFileEntry } from '@interfaces/mfe/mfe-document-upload.interface';
import { DocumentSlice, FileDescriptor } from '@interfaces/models/doc-types';
import { createAction, props } from '@ngrx/store';
import { ClearData } from '@shared/models';

import { IFileMetaData } from '../../reducers/document-upload/document-upload.reducer';

export const updateFilesMetaData = createAction(
  '[Document Upload] Update Files Metadata',
  props<{ payload: IFileMetaData[] }>(),
);

export const updateProspectClearDocuments = createAction(
  '[Document Upload] Updating prospect clear document(s)',
  props<{ payload: ClearData }>(),
);

export const updateSelectedAccountTypes = createAction(
  '[Document Upload] Updating selected account types',
  props<{ payload: string[] }>(),
);

export const uploadDocumentsToS3 = createAction(
  '[Document Upload] Upload Documents to S3',
  props<{ filesMetadata: IFileMetaData[] }>(),
);

export const uploadDocumentsSuccess = createAction('[Document Upload] Upload Documents Success');

export const uploadDocumentsFailed = createAction('[Document Upload] Upload Documents Failed');

export const fetchDocumentsFromS3 = createAction(
  '[Document Upload] Fetch Documents from S3',
  props<{ fileDescriptors?: FileDescriptor[]; slice?: DocumentSlice }>(),
);

export const fetchDocumentsSuccess = createAction('[Document Upload] Fetch Documents Success');

export const fetchDocumentsFailed = createAction('[Document Upload] Fetch Documents Failed');

export const clearDocumentsError = createAction('[Document Upload] Clear Documents Error');

export const clearDocumentUpload = createAction('[Document Upload] Clear');

export type WldDocumentSlice = 'standard' | 'letter' | 'tax';

export const addWldDocument = createAction(
  '[Document Upload - WLD MFE] Add Document',
  props<{ slice: WldDocumentSlice; document: UploadedFileEntry }>(),
);

export const removeWldDocument = createAction(
  '[Document Upload - WLD MFE] Remove Document',
  props<{ slice: WldDocumentSlice; documentId: string }>(),
);

export const clearWldDocuments = createAction(
  '[Document Upload - WLD MFE] Clear Documents',
  props<{ slice?: WldDocumentSlice }>(),
);

// WLD Terms Actions
export const loadWldTermsContent = createAction('[Document Upload - WLD Terms] Load Terms Content');

export const loadWldTermsContentSuccess = createAction(
  '[Document Upload - WLD Terms] Load Terms Content Success',
  props<{ payload: WldTermsContent }>(),
);

export const loadWldTermsContentFailure = createAction(
  '[Document Upload - WLD Terms] Load Terms Content Failure',
  props<{ error: string }>(),
);

export const acceptWldTerms = createAction('[Document Upload - WLD Terms] Accept Terms');

export const acceptWldTermsSuccess = createAction(
  '[Document Upload - WLD Terms] Accept Terms Success',
  props<{ payload: WldDocumentSharingConsent }>(),
);

export const acceptWldTermsFailure = createAction(
  '[Document Upload - WLD Terms] Accept Terms Failure',
  props<{ error: string }>(),
);

export const loadWldConsentStatus = createAction(
  '[Document Upload - WLD Terms] Load Consent Status',
  (payload: { force?: boolean } = {}) => ({ force: false, ...payload }),
);

export const loadWldConsentStatusSuccess = createAction(
  '[Document Upload - WLD Terms] Load Consent Status Success',
  props<{ payload: WldDocumentSharingConsent }>(),
);

export const loadWldConsentStatusFailure = createAction(
  '[Document Upload - WLD Terms] Load Consent Status Failure',
  props<{ error: string }>(),
);

export const setS3BucketFileNames = createAction(
  '[Document Upload] Set S3 Bucket File Names',
  props<{ payload: { objectURL: string; s3BucketFileName: string }[] }>(),
);

export const rehydrateFilesFromS3 = createAction(
  '[Document Upload] Rehydrate Files From S3',
  props<{ payload: { s3BucketFileName: string; objectURL: string }[]; slice?: DocumentSlice }>(),
);

export const deleteDocumentsFromS3 = createAction(
  '[Document Upload] Delete Documents from S3',
  props<{ fileDescriptors: FileDescriptor[] }>(),
);

export const deleteDocumentsSuccess = createAction('[Document Upload] Delete Documents Success');

export const deleteDocumentsFailed = createAction('[Document Upload] Delete Documents Failed');
